<template>
    <div>
        <BigTitle />
        <div class="row">
            <div class="col-10 offset-1">
                <div class="shadow rounded d-flex d-column justify-content-center" style="padding-top:50px;padding-bottom:50px;">
                    <b-form v-on:submit="onSubmit" style="width:400px;" >
                        <b-form-group
                            id="input-group-username"
                            label="用户名："
                            label-for="input-username">
                            <b-form-input
                                id="input-username"
                                v-model="form.username"
                                type="text"
                                required
                                placeholder="Enter username">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group
                            id="input-group-password"
                            label="密码："
                            label-for="input-password">
                            <b-form-input
                                id="input-password"
                                v-model="form.password"
                                type="password"
                                required
                                placeholder="Enter password">
                            </b-form-input>
                        </b-form-group>
                        <b-button type="submit" variant="primary">确认</b-button>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import BigTitle from '../components/BigTitle'

import axios from 'axios'
// import GlobalConstant from '../constants/GlobalConstant'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
    "name": "AdminLogin",
    data: function(){
        return {
            form: {
                username:"",
                password:""
            }
        }
    },
    components: {
        BigTitle
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault()
            axios({
                url: '/api/admin/login',
                method: 'post',
                data: this.form,
                // headers: { 
                //     'Content-Type': 'multipart/form-data'
                // },
            }).then((response) => {
                console.log(response);
                var res = response.data;
                if(res.code == 1){
                    var token = res.data;
                    console.log(token);
                    const ss = window.sessionStorage
                    ss.setItem('token', token);
                    console.log(ss.getItem('token'));
                    window.location.href='/admin/editBlog';
                }else{
                    this.$bvToast.toast('登录失败: ' + res.msg, {
                        title: `错误`,
                        toaster: 'b-toaster-top-right',
                        variant: 'danger',
                        solid: true,
                        appendToast: false
                    })
                }
           }).catch(function(error){
               this.$bvToast.toast('出现异常！' + error, {
                    title: `错误`,
                    toaster: 'b-toaster-top-right',
                    variant: 'danger',
                    solid: true,
                    appendToast: false
                })
           });
        },
    }
}



</script>


<style>
    
</style>